/**
 * Renderizador de ícones de geometria GeoJSON e feições espaciais.
 *
 * Suporta strings SVG completas com auto-escalonamento via CSS (independente
 * das dimensões nativas 24x24 do SVG) ou caracteres/emojis legados como fallback.
 *
 * @module components/GeometryIcon
 */

/**
 * @param {object} props
 * @param {string} props.icon - String contendo código SVG ou caractere
 * @param {number} [props.size=14] - Dimensão em pixels (largura e altura)
 * @param {string} [props.color] - Cor do traço/ícone (padrão: currentColor)
 * @param {object} [props.style] - Estilos inline adicionais
 * @param {string} [props.className] - Classes CSS complementares
 */
export default function GeometryIcon({
  icon,
  size = 14,
  color,
  style = {},
  className = "",
}) {
  if (!icon) return null;

  const isSvg = typeof icon === "string" && icon.trim().startsWith("<svg");

  if (isSvg) {
    return (
      <span
        className={`geom-svg-icon ${className}`}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: size,
          height: size,
          lineHeight: 1,
          flexShrink: 0,
          color: color || "currentColor",
          ...style,
        }}
        dangerouslySetInnerHTML={{ __html: icon }}
      />
    );
  }

  return (
    <span
      style={{
        fontSize: size,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
      className={className}
    >
      {icon}
    </span>
  );
}
